// extracted by mini-css-extract-plugin
module.exports = {"container":"part-partner_container__iTqXb","title":"part-partner_title__Yj2AF","iconWrap":"part-partner_iconWrap__utHd5","listsWrap":"part-partner_listsWrap__XfXUa"};